/**
 * @copyright NIIT Technologies Ltd. 2017-18.
 */

// Angular
import { NgModule } from '@angular/core';

// NGC Message Controls

/**
 * NGC Message Module
 */

export class NgcMessageModule {
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    exports: [

    ]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}
interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
